import axios from 'axios';
// import Cookies from 'universal-cookie'
import _ from 'lodash'
import { Message } from 'element-ui';
import util from '@/libs/util';
// import { transData, transDateToMoment, flattenQueryParams } from './index'

async function request(options: any, catchFunc?:any) {
  // const cookies = new Cookies();
  // const token = localStorage.getItem('access_token');// cookies.get('access_token');
  const token = util.cookies.get('token');
  const axiosConfig = {
    ...options,
  };
  if (token) {
    axiosConfig.headers = {'Authorization': `Bearer ${token}`};
  }
  try {
    const response = await axios(axiosConfig);

    if (response.data && response.data.message) {
      Message({
        message: response.data.message
      })
    }
    return response.data;
    // return transDateToMoment(response.data);
  } catch (error) {
    if (error.response) {
      if (error.response.status === 401) {
        window.location.href = "/#/login"
      } else {
        const msgKeys = ['message', 'error_message', 'data.msg', 'data.errmsg', 'data.message'];
        const msg = _.chain(msgKeys).map((k) => _.get(error.response, k)).filter(v => !_.isEmpty(v)).first().value();
        let err: any =  new Error(msg);
        if (_.has(error.response.data, 'code')) {
          err.code = error.response.data.code
        }
        if (_.has(error.response.data, 'fieldErrors')) {
          err.fieldErrors = error.response.data.fieldErrors
        }
        throw err
      }
    } else {
      throw new Error(error.message || '不知道发生了什么')
    }
  }
}

request.get = async function(url: string, params?: any) {
  return request({
    url,
    method: 'GET',
    params,
  })
};
request.post = async function(url: string, data?: any) {
  return request({
    url,
    method: 'POST',
    data,
  })
};
request.put = async function(url: string, data?: any) {
  return request({
    url,
    method: 'put',
    data,
  })
};
request.delete = async function(url: string, data?: any) {
  return request({
    url,
    method: 'DELETE',
    data,
  })
};
export default request;
